import api from "@resources/js/http/api";


export const sendStatsService = (options) => {
    api.post('/log/event/', options)
        .then(response => {
            if (!response.data.success) {
                console.error('Failed to send stats, check required options.', options)
            }
        })
        .catch(error => console.error(error))
}
